import {JobCreatedFromQuoteNotificationDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";

/**
 * Job created from quote notification class data.
 */
export default class JobCreatedFromQuoteNotificationData {
	/**
	 * @param {string} jobId Created job id.
	 * @param {string} referenceNumber Job reference number.
	 * @param {AuthenticatedEntity} creator Job creator.
	 */
	constructor(readonly jobId: string,
		readonly referenceNumber: string,
		public readonly creator: AuthenticatedEntity) {}

	static fromJson(json: JobCreatedFromQuoteNotificationDataApiDto): JobCreatedFromQuoteNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new JobCreatedFromQuoteNotificationData(
			json.jobId,
			json.referenceNumber,
			creator)
	}
}
